import { hexToRgba } from "../theme-utils/color-utils.js";
const formatStops = (stops) => [...stops ?? []].filter((stop) => stop.color).sort((a, b) => (a.position ?? 0) - (b.position ?? 0)).map((stop) => `${hexToRgba(stop.color)} ${((stop.position ?? 0) * 100).toFixed(2)}%`).join(", ");
const schemaGradientToCss = (gradient) => {
  if (!gradient) {
    return "";
  }
  if (gradient.type === "LINEAR") {
    return `linear-gradient(${gradient.angle ?? 90}deg, ${formatStops(gradient.stops)})`;
  }
  if (gradient.type === "RADIAL") {
    return `radial-gradient(circle at ${gradient.centerX ?? 50}% ${gradient.centerY ?? 50}%, ${formatStops(gradient.stops)})`;
  }
  return "";
};
export {
  schemaGradientToCss
};
//# sourceMappingURL=schema-gradient-to-css.js.map
